import React, { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

function Activities() {
  const [data, setData] = useState({ header: {}, cards: [] });

  /* ===== SCROLL ANIMATION ===== */
  useEffect(() => {
    const section = document.querySelector(".activities-section");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && section) {
          section.classList.add("in-view");
        }
      },
      { threshold: window.innerWidth < 992 ? 0.05 : 0.25 }
    );

    if (section) observer.observe(section);
    return () => observer.disconnect();
  }, []);

  /* ===== JSON + XML ===== */
  useEffect(() => {
    // ✅ JSON (UI)
    fetch("/api/activities.json")
      .then(res => res.json())
      .then(json => {
        console.log("ACTIVITIES JSON:", json);
        setData(json);
      })
      .catch(err => console.error("ACTIVITIES JSON ERROR:", err));

    // ✅ XML (exam / proof)
    fetch("/api/activities.xml")
      .then(res => res.text())
      .then(() => console.log("Activities XML loaded"));
  }, []);

  return (
    <>
      <section className="activities-section">
        {/* ===== HEADER ===== */}
        <div className="activities-header">
          <h3 className="section-title1">
            <img src={data.header.icon} alt="logo" width="30" />
            {data.header.title}
          </h3>

          <h2>{data.header.subtitle}</h2>
        </div>

        {/* ===== CARDS ===== */}
        <div className="activities-cards">
          {data.cards.map((card, index) => (
            <div
              key={index}
              className={`activity-card ${card.animation}`}
            >
              <img src={card.image} alt={card.title} />

              <div className="card-content">
                <h4 className="card-title">
                  {card.title} <span></span>
                </h4>

                {card.subtitle && (
                  <h6 className="card-subtitle">{card.subtitle}</h6>
                )}

                <p>{card.description}</p>

                <Link to={card.link} className="read-more">
                  Read More <FaArrowRight />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>


      <style>{`
/* ================= ACTIVITIES SECTION ================= */

.activities-section,
.activities-section * {
  font-family: var(--secondary-font-family) !important;
}

.activities-section {
  margin: 0 auto;
  padding: 50px 20px;
  text-align: center;
  background:
    linear-gradient(to top, rgba(255,255,255,1) 36%, rgba(255,255,255,0) 36%),
    url('/assets/activities/bg.jpg') no-repeat center bottom / cover;
  margin-top: 29px;
}

/* HEADER */
.section-title1 {
  font-family: var(--primary-font-family);
  font-size: 33px;
  font-weight: 700;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 17px;
}

.section-title1::after {
  content: "";
  height: 2px;
  width: 52px;
  background-color: var(--primary-color);
}

.activities-header h2 {
  font-size: 29px;
  margin-top: 10px;
  font-weight: 600;
  color: #fff;
}

/* GRID */
.activities-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  margin-top: 40px;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

/* CARD */
.activity-card {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  padding: 10px;
  opacity: 0;
  transition: all 0.9s ease;
}

/* IMAGE */
.activity-card img {
  width: 100%;
  height: 260px;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.activity-card img:hover {
  transform: translateY(-8px);
}

.card-content {
  padding: 20px;
}

/* TITLES */
.card-title {
  font-family: var(--primary-font-family);
  font-size: 24px;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 10px;
}

.card-title span {
  display: inline-block;
  margin-left: 10px;
  height: 2px;
  width: 40px;
  background: #8bc53f;
}

/* TEXT */
.card-content p {
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 15px;
  color: #000;
}

/* BUTTON */
.read-more {
  display: inline-block;
  padding: 14px 22px;
  font-weight: 700;
  font-size: 16px;
  color: #000;
  background-color: var(--primary-color);
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.4s ease;
}

.read-more:hover {
  background: #000;
  color: #fff;
  transform: translateY(-3px) scale(1.05);
}

/* ================= ANIMATIONS ================= */

.reveal-left { transform: translateX(-80px); }
.reveal-right { transform: translateX(80px); }
.reveal-center { transform: translateY(60px); }

.activities-section.in-view .reveal-left,
.activities-section.in-view .reveal-right,
.activities-section.in-view .reveal-center {
  opacity: 1;
  transform: translateX(0) translateY(0);
}

/* RESPONSIVE */
@media (max-width: 992px) {
  .activities-cards {
    grid-template-columns: 1fr;
  }
}
  
      `}</style>
    </>
  );
}

export default Activities;
